import useSWR from "swr";
import fetchColumnValue from "./fetchColumnValueResync";

const useColumnValue = (items: any, syncId: string) => {
  const fetcher = () => fetchColumnValue(items, syncId);

  const shouldFetch = items && items.length > 0;

  const key = shouldFetch ? `discrepancyBoard:${syncId}` : null;

  const { data, error, isValidating, isLoading } = useSWR(key, fetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 10000, // Cache for 5 minutes
  });

  return {
    itemColumnValues: data?.groupedColumns || {},
    totalDiscrepancies: data?.totalDiscrepancies ?? null,
    error,
    isLoading,
    isValidating,
  };
};

export default useColumnValue;
